const MD = require('mobile-detect'); // Node import to avoid MobileDetect type conflict
function isAbove(version, nb) {
    if (!version) {
        return false;
    }
    return !Number.isNaN(version) && version >= nb;
}
const detect = (userAgent) => {
    const md = new MD(userAgent);
    const result = {
        mobile: md.mobile(),
        phone: md.phone(),
        tablet: md.tablet(),
        userAgent,
        os: md.os(),
        iphone: md.is('iPhone'),
        isBot: md.is('bot'),
        chrome: md.version('Chrome'),
        firefox: md.version('Firefox'),
        webkit: md.version('Webkit'),
        ie: md.version('IE'),
        edge: md.version('Windows NT'),
        ios: md.version('iOS'),
        android: md.version('Android'),
        wsParams: {
            isMobile: !!md.mobile() && !md.tablet(),
            isTablet: !!md.tablet(),
        },
        isEmbeddedInBuyerApp: userAgent.includes('BuyerApp') || userAgent.includes('MSAppHost'),
        isEmbbedInBuyerApp: userAgent.includes('BuyerApp') || userAgent.includes('MSAppHost'),
        onload: false,
    };
    if (result.os === 'AndroidOS' && isAbove(result.chrome, 64)) {
        result.onload = true;
    }
    else if (result.os === 'iOS') {
        result.onload = isAbove(result.ios, 11.3) && (userAgent === 'Chrome' || result.userAgent === 'Safari');
    }
    else if (!result.mobile) {
        result.onload = isAbove(result.chrome, 62) || isAbove(result.firefox, 100) || isAbove(result.edge, 17);
    }
    else {
        result.onload = false;
    }
    return result;
};
const getWsUrlParams = (userAgent) => {
    const md = detect(userAgent);
    return md.wsParams;
};
export const md = {
    detect,
    getWsUrlParams,
};
